<span class="badge badge-pedido-status badge-pedido-status-nao-confirmado">
    {{status.nome}}
</span>